import React from 'react';
import logoTncWhite from '../../assets/images/logo-tnc-white.png';
import './footer.scss';

const Footer = ({ home }) => {
  return (
    <footer className={`footer ${home ? 'home' : ''}`}>
      <span className='footer-label'>Un evento</span>
      <img src={logoTncWhite} alt='TNC' className='footer-logo' />
    </footer>
  );
};

export default Footer;
